package devxertech.com.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.onBlur
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onFocusIn
import com.varabyte.kobweb.compose.ui.modifiers.onFocusOut
import com.varabyte.kobweb.compose.ui.modifiers.onKeyDown
import com.varabyte.kobweb.compose.ui.modifiers.onKeyUp
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleRight
import devxertech.com.style.LoginInputStyleDefault
import devxertech.com.style.LoginInputStyleFocus
import devxertech.com.theme.SitePalette
import kotlinx.browser.document
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLInputElement


@Composable
fun PaginationNumberComponent(
    id: String = "",
    currentPage: Int,
    totalPages: Int,
    onPageChange: (Int) -> Unit,
    width: CSSLengthOrPercentageNumericValue = 400.px,
    sitePalette: SitePalette,
    disabled: Boolean = false,
    flexWrapAllow: Boolean = true
) {
    var pageInput by remember { mutableStateOf(currentPage.toString()) }
    var isUserTyping by remember { mutableStateOf(false) }

    val scope = rememberCoroutineScope()

    LaunchedEffect(currentPage) {
        if (!isUserTyping) {
            pageInput = currentPage.toString()
        }
    }

    var modifier by remember { mutableStateOf(LoginInputStyleDefault) }

    LaunchedEffect(currentPage) {
        (document.getElementById(id) as? HTMLInputElement)?.value = currentPage.toString()
    }

    modifier =
        if (disabled) modifier.border(width = 0.px)
        else (if (modifier == LoginInputStyleFocus) LoginInputStyleFocus else LoginInputStyleDefault)

    fun validateAndUpdatePage() {
        isUserTyping = false
        val inputElement = document.getElementById(id) as? HTMLInputElement
        val rawInput = inputElement?.value?.toIntOrNull()
        if (rawInput != null) {
            val validPage = rawInput.coerceIn(1, totalPages)
            inputElement.value = validPage.toString()
            pageInput = validPage.toString()
            onPageChange(validPage)
        } else {
            inputElement?.value = currentPage.toString()
            pageInput = currentPage.toString()
        }
    }

    Row(
        modifier = Modifier
            .padding(8.px)
            .width(width)
            .flexWrap(if (flexWrapAllow) FlexWrap.Wrap else FlexWrap.Nowrap),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        // Previous Page Button
        Box(
            modifier = Modifier
                .size(35.px)
                .cursor(Cursor.Pointer)
                .borderRadius(5.px)
                .border(
                    width = 1.px,
                    color = sitePalette.textFieldBorderColor.rgb,
                    style = LineStyle.Solid
                )
                .padding(8.px)
                .onClick {
                    if (currentPage > 1) {
                        onPageChange(currentPage - 1)
                    }
                },
            contentAlignment = Alignment.Center
        ) {
            FaAngleLeft(
                modifier = Modifier.color(
                    if (currentPage > 1) sitePalette.textFieldTextColor.rgb else Colors.Gray
                )
            )
        }

        CustomSpacer(13.px)
        FieldTitleTextNormalSimple("Page")
        CustomSpacer(13.px)

        // Page Input Field
        Input(
            type = InputType.Text,
            attrs = Modifier
                .id(id)
                .width(45.px)
                .height(39.px)
                .borderRadius(5.px)
                .border(
                    width = 1.px,
                    color = sitePalette.textFieldBorderColor.rgb,
                    style = LineStyle.Solid
                )
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .color(sitePalette.textFieldTextColor.rgb)
                .textAlign(TextAlign.Center)
                .onFocusIn {
                    modifier = LoginInputStyleFocus
                }.onFocusOut {
                    modifier = LoginInputStyleDefault
                }
                .fontSize(14.px)
                .padding(leftRight = 8.px)
                .onFocusIn { isUserTyping = true }
                .onKeyDown {
                    if (it.key != "Backspace") {
                        val regex = "[\\d]".toRegex()
                        val value = (document.getElementById(id) as HTMLInputElement).value

                        if (regex.matches(it.key)) {
                            if (it.key == "." && value.contains(".")) {
                                it.preventDefault()
                            }
                        } else {
                            it.preventDefault()
                        }
                    }
                }
                .onKeyUp { event ->
                    if (event.key == "Enter") {
                        val pageInputField = (document.getElementById(id) as? HTMLInputElement)
                        val pageInputValue = pageInputField?.value?.toInt()
                        if (pageInputValue != null) {
                            if (pageInputValue > totalPages) {
                                pageInputField.value = totalPages.toString()
                                pageInput = totalPages.toString()
                            } else if (pageInputValue < 1) {
                                pageInputField.value = "1"
                                pageInput = "1"
                            }
                            validateAndUpdatePage()
                        }
                        (document.getElementById(id) as? HTMLInputElement)?.blur()
                    }
                }
                .onBlur {
                    validateAndUpdatePage()
                }
                .toAttrs {
                    onInput { event ->
                        val value = event.value
                        if (value.all { it.isDigit() }) {
                            isUserTyping = true
                            val number = value.toIntOrNull()
                            if (number != null) {
                                pageInput = value
                            }
                        }
                    }
                }
        )

        CustomSpacer(13.px)
        FieldTitleTextNormalSimple("of $totalPages")
        CustomSpacer(13.px)

        // Next Page Button
        Box(
            modifier = Modifier
                .size(35.px)
                .cursor(Cursor.Pointer)
                .borderRadius(5.px)
                .border(
                    width = 1.px,
                    color = sitePalette.textFieldBorderColor.rgb,
                    style = LineStyle.Solid
                )
                .padding(8.px)
                .onClick {
                    if (currentPage < totalPages) {
                        onPageChange(currentPage + 1)
                    }
                },
            contentAlignment = Alignment.Center
        ) {
            FaAngleRight(
                modifier = Modifier.color(
                    if (currentPage < totalPages) sitePalette.textFieldTextColor.rgb else Colors.Gray
                )
            )
        }
    }
}
